<div class="modal support-modal">
  <i class="fal fa-times modal__close"
     (click)="close()"></i>

  <div class="support-dialog__body p-0125 align-center">
    <p>
      <img src="/assets/icons/maskable_icon.png"
           width="80"
           alt="ActionBuilder App Icon"
           style="border-radius:8px">
    </p>
    <h2 class="pt-0050 mb-0050 pb-0 border-0">Add to Home Screen</h2>
    <p class="color--gray--03 mt-0 mb-0">
      Save <strong>Action Builder</strong> to your home screen for quick and easy access when you&rsquo;re on the go.
    </p>
  </div>
  <div class="support-dialog__footer align-center bg-color--gray p-0125 pt-0075 pb-0075">
    <p class="color--gray--02 mt-0025">
      <ng-container *ngIf="isIOS()">
        Just tap
        <i class="far fa-arrow-up-from-square color--blue txt-16 ml-0012 mr-0012 pos-relative"
           style="top:-1px"></i>
        then <span class="nowrap">&ldquo;Add to Home Screen&rdquo;</span>.
      </ng-container>
      <ng-container *ngIf="isAndroid()">
        Just tap your browser&rsquo;s menu button
        then <span class="nowrap">&ldquo;Add to Home Screen&rdquo;</span>.
      </ng-container>
    </p>
  </div>
</div>
